import { useQuery } from '@tanstack/react-query';
import { ClinicalNoteApi } from '../../../apis/ClinicalNoteApi/ClinicalNoteApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { ClinicalNote, IClinicalNote } from '../ClinicalNote';

export function useCounsellingNoteForPatientByTask(taskId: string | number | null | undefined) {
    return useQuery<ClinicalNote | null>({
        queryKey: [QueryKeys.clinicalNotes, 'patientViewByTask', taskId == null ? null : String(taskId)],
        enabled: taskId != null,
        queryFn: async () => {
            if (taskId == null) return null;
            const data: IClinicalNote = await ClinicalNoteApi.getCounsellingNoteForPatientByTask(String(taskId));
            return new ClinicalNote(data);
        },
    });
}
